import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { TenantService } from '../tenants/tenant.service';
import { toDevProxyUrl } from './dev-proxy';

export const tenantBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantService = inject(TenantService);
  const devProxy = inject(ConfigService).devProxy;

  // Only intercept relative URLs that start with /api/
  if (req.url.startsWith('/api/')) {
    const tenant = tenantService.selectedTenant();

    if (!tenant) {
      throw new Error('No tenant selected. Please select a tenant before accessing this feature.');
    }

    // Clone the request with the full URL
    const url = `${tenant.apiUrl}${req.url}`;
    const modifiedReq = req.clone({
      url: devProxy ? toDevProxyUrl(url, tenant.apiUrl) : url
    });

    return next(modifiedReq);
  }

  // Pass through absolute URLs unchanged, unless they point at the tenant's backend
  // while the dev proxy is on
  const proxiedUrl = devProxy
    ? toDevProxyUrl(req.url, tenantService.selectedTenant()?.apiUrl)
    : req.url;

  return proxiedUrl === req.url ? next(req) : next(req.clone({ url: proxiedUrl }));
};
